import { FieldTypes } from '../constants'
import { DropdownField } from '../types'

export const educationStatusField: DropdownField = {
  placeholder: 'Education Status',
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'none', text: 'None' },
    { id: 'some-high-school', text: 'Some High School' },
    { id: 'high-school', text: 'High School' },
    { id: 'some-college', text: 'Some College' },
    { id: 'associates', text: 'Associates Degree' },
    { id: 'bachelors', text: 'Bachelors Degree' },
    { id: 'masters', text: 'Masters Degree' },
    { id: 'doctoral', text: 'Doctoral Degree' },
    { id: 'professional', text: 'Professional Degree' },
  ],
}
